(() => {
  const node = document.getElementById('bragado-upsell-config');
  if (!node || customElements.get('bragado-cart-offer')) return;
  const config = JSON.parse(node.textContent), t = config.text;
  const root = window.Shopify?.routes?.root || '/', code = 'BRAGADO2FOR105';
  const escape = value => String(value).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  async function request(path, data) {
    const response = await fetch(root + path, {method:data ? 'POST':'GET',headers:{'Content-Type':'application/json'},credentials:'same-origin',...(data ? {body:JSON.stringify(data)}:{})});
    if (!response.ok) throw new Error(t.error);
    return response.json();
  }
  function eligible(cart) {
    const item = cart.items?.[0];
    return cart.currency === 'USD' && cart.item_count === 1 && cart.items.length === 1 && config.products.some(p => p.id === item.product_id) && item.original_price === 6500 && cart.total_price === 6500 && !item.selling_plan_allocation && !Object.keys(item.properties || {}).length && !(cart.discount_codes || []).some(d => d.code.toUpperCase() !== code);
  }
  customElements.define('bragado-cart-offer',class extends HTMLElement {
    connectedCallback() { this.refresh(); }
    async refresh() {
      if (this.busy || this.loading) return;
      this.loading = true;
      try {
        const cart = await request('cart.js');
        if (!this.isConnected) return;
        if (!eligible(cart)) {this.hidden = true;this.replaceChildren();return;}
        const originalId = cart.items[0].variant_id;
        const products = await Promise.all(config.products.filter(p => p.id !== cart.items[0].product_id).map(p => request('products/'+p.handle+'.js')));
        const choices = products.map(p => ({...p,variants:p.variants.filter(v => v.available && v.price === 6500)})).filter(p => p.variants.length);
        if (!this.isConnected || !choices.length) {this.hidden = true;return;}
        this.innerHTML = `<h3>${escape(t.heading)}</h3><p>${escape(t.summary)}</p>${choices.map(p => `<article><img src="${escape(p.featured_image)}${p.featured_image.includes('?') ? '&':'?'}width=160" alt="${escape(p.title)}" width="72" height="88" loading="lazy"><div><h4>${escape(p.title)}</h4><div class="bragado-offer-controls"><label class="visually-hidden" for="upsell-${p.id}">${escape(p.title)} ${escape(t.size)}</label><select id="upsell-${p.id}"><option value="">${escape(t.choose)}</option>${p.variants.map(v => `<option value="${v.id}">${escape(v.title)}</option>`).join('')}</select><button type="button" data-add disabled>${escape(t.add)}</button></div></div></article>`).join('')}<p role="status" aria-live="polite" data-status></p><a href="${root}cart" data-review hidden>${escape(t.review_cart)}</a><small>${escape(t.terms)}</small>`;
        this.hidden = false;
        this.querySelectorAll('article').forEach(article => {
          const select = article.querySelector('select'), button = article.querySelector('button');
          select.addEventListener('change',event => {event.stopPropagation();button.disabled = !select.value;});
          button.addEventListener('click',() => this.add(Number(select.value),originalId));
        });
      } catch (_) {this.hidden = true;} finally {this.loading = false;}
    }
    async add(variant,originalId) {
      if (this.busy || !variant) return;
      this.busy = true;
      const drawer = this.closest('cart-drawer');
      const controls = [...drawer.querySelectorAll('button,input,select')].filter(el => !el.disabled && !el.classList.contains('drawer__close'));
      controls.forEach(el => {el.disabled = true;});
      const status = this.querySelector('[data-status]');status.textContent = t.adding;
      let attempted = false;
      try {
        const current = await request('cart.js');
        if (!eligible(current) || current.items[0].variant_id !== originalId) throw new Error(t.changed);
        attempted = true;
        await request('cart/add.js',{items:[{id:variant,quantity:1}]});
        const discounted = await request('cart/update.js',{discount:code,sections:drawer.getSectionsToRender().map(s => s.id),sections_url:window.location.pathname});
        if (discounted.item_count !== 2 || discounted.total_price !== 10500 || !discounted.discount_codes?.some(d => d.code.toUpperCase() === code && d.applicable)) throw new Error(t.review);
        if (!discounted.sections || Object.values(discounted.sections).some(s => !s)) {window.location.assign(root+'cart');return;}
        drawer.renderContents(discounted);
      } catch (error) {
        status.textContent = attempted ? t.review : error.message;
        this.querySelector('[data-review]').hidden = false;
        if (attempted) this.querySelectorAll('select,[data-add]').forEach(el => el.dataset.failed = 'true');
      } finally {
        this.busy = false;
        controls.forEach(el => {if (!el.dataset.failed) el.disabled = false;});
      }
    }
  });
})();
